import { render, staticRenderFns } from "./VCostInput.vue?vue&type=template&id=3b8c13d6&"
import script from "./VCostInput.vue?vue&type=script&lang=js&"
export * from "./VCostInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports